import messages from './cmsBanner.json' with { type: 'json' };

export const cmsBannerEn: Readonly<typeof messages> = messages;
